import { Auth } from '@aws-amplify/auth';
import AsyncStorage from '@react-native-async-storage/async-storage';

const signOut = () => {
  AsyncStorage.clear();
  Auth.signOut();
};

export default signOut;
